export const ApprovedByOwner = 'approved_by_owner';
export const NotApproved = 'not_approved';
export const AutoApproved = 'auto_approved';
